import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ANONYMOUS_MAIN_ROUTE_NAME,
  TRANSLATION_GROUP_ANONYMOUS_MAIN,
} from './constants';
import { getTranslationKeys } from './translations';

export class AnonymousMainModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAnonymousRoute({
      name: ANONYMOUS_MAIN_ROUTE_NAME,
      path: '/',
      component: () => import('./pages/MainAnonymousPage/MainAnonymousPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_ANONYMOUS_MAIN, getTranslationKeys);
  }
}
